<script setup lang="ts">
import { ref, computed } from 'vue'
import { Dialog } from 'quasar'
import { ConditionBlock } from '@/models/v2/document/elements/control/block/ConditionBlock'
import EditConditionDialog from '../../../dialogs/EditConditionDialog.vue'
import BlockElementView from '../../../BlockElementView.vue'
import draggable from 'vuedraggable'

interface Props {
  data: ConditionBlock
}

const props = withDefaults(defineProps<Props>(), {})

const isHovering = ref(true)
const hover = ref(false)

const cardClass = computed(() => {
  let classes = 'full-width'
  classes += ' block top-left-corner-angle'

  return classes
})

function showEditConditionDialog() {
  const dialog = Dialog.create({
    component: EditConditionDialog,
    componentProps: {
      condition: props.data,
    },
  })
    .onOk(() => {
      dialog.hide()
    })
    .onCancel(() => {
      dialog.hide()
    })
}
</script>

<template>
  <div class="column items-start" @mouseover="hover = true" @mouseleave="hover = false">
    <q-badge @click="showEditConditionDialog()" class="badge-corner" align="top" v-if="isHovering">
      <span class="material-icons-outlined"> quiz </span>
      <span v-if="data.label !== undefined && data.label !== ''">
        {{ data.label }}
      </span>
      <span v-if="data.label === undefined || data.label === ''"> Condition </span>
    </q-badge>
    <q-card flat bordered :class="cardClass">
      <q-card-sections horizontal class="row items-center justify-start no-wrap q-pl-none q-pt-sm q-pb-sm q-pr-sm">
        <q-icon name="drag_handle" class="handle" :color="hover ? 'black' : 'transparent'"> </q-icon>
        <div class="condition-block-view full-width">
          <draggable
            class="drag-area q-gutter-sm"
            tag="div"
            :list="data.elements"
            :group="{ name: 'g1' }"
            item-key="id"
            handle=".handle"
          >
            <template #item="{ element, index }">
              <BlockElementView :element="element"></BlockElementView>
            </template>
          </draggable>
        </div>
      </q-card-sections>
    </q-card>
  </div>
</template>

<style lang="scss" scoped></style>
